import React, { useState } from "react";
import ReactSelect from "react-select";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000811",
    whiteSpace: "nowrap",
  }),
};

const FieldSkeleton = () => (
  <div>
    <div
      style={{
        height: "12px",
        width: "40%",
        backgroundColor: "#E4E7EA",
        borderRadius: "4px",
        marginBottom: "8px",
      }}
    />
    <div
      style={{
        height: "35px",
        width: "100%",
        backgroundColor: "#EEF1F3",
        borderRadius: "6px",
      }}
    />
  </div>
);

const UserInformationSkeleton = () => (
  <div className="card">
    <div className="card-header">
      <h2>Personal Information</h2>
    </div>
    <div className="card-body">
      <div className="row">
        {[1, 2, 3].map((n) => (
          <div
            key={n}
            className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2"
          >
            <FieldSkeleton />
          </div>
        ))}
      </div>
      <div className="row">
        {[1, 2, 3].map((n) => (
          <div
            key={n}
            className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2"
          >
            <FieldSkeleton />
          </div>
        ))}
      </div>
      <div className="row">
        {[1, 2].map((n) => (
          <div
            key={n}
            className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2"
          >
            <FieldSkeleton />
          </div>
        ))}
        <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 mb-2">
          <FieldSkeleton />
        </div>
      </div>
    </div>
  </div>
);

const UserInformation = (props) => {
  const {
    loading,
    userTypedrp,
    handleUserTypeChange,
    userType,
    formErrors,
    formValues,
    handleFormChange,
    showPassword,
    showConfirmPassword,
    userRoleDrp,
    handleUserRoleChange,
    UserRoleName,
    distributorDrp,
    companyDrp,
    handleCompanyChange,
    companyName,
    departmentDrp,
    handleDepartmentChange,
    departmentName,
    designationDrp,
    handleDesignationChange,
    designationName,
    userReportDrp,
    handleUserReportingChange,
    UserReportingName,
    handleToggleChange,
    clearFormValues,
    setFormErrors,
    setFormValues
  } = props;
  const [isBlock, setIsBlock] = useState(false);
  const [showPwd, setShowPwd] = useState(false)

  function handleToggleBlockChange() {
    const newValue = !isBlock;
    setIsBlock(newValue)
    setFormValues({ ...formValues, isActive: newValue });
  }

  if (loading) {
    return <UserInformationSkeleton />;
  }

  return (
    <>
      <div className="card mb-2">
        <div className="card-header">
          <h2>Personal Information</h2>
        </div>
        <div className="card-body bg-white">
          <div className="row">
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  User Type <span className="mandatory">*</span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  hideSelectedOptions={false}
                  allowSelectAll={true}
                  options={userTypedrp}
                  onChange={handleUserTypeChange}
                  value={userType}
                  name="userType"
                  id="userType"
                  placeholder={PlaceHolder?.SELECT_USER_TYPE}
                  styles={style}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
                {formErrors?.userType && (
                  <p className="form-error">{formErrors?.userType}</p>
                )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  First Name <span className="mandatory">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder={PlaceHolder?.FIRST_NAME}
                  name="firstName"
                  id="firstName"
                  value={formValues.firstName}
                  onChange={handleFormChange}
                />
              </div>
              {formErrors.firstName && (
                <p className="form-error">{formErrors.firstName}</p>
              )}
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Last Name <span className="mandatory">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder={PlaceHolder?.LAST_NAME}
                  name="lastName"
                  id="lastName"
                  value={formValues.lastName}
                  onChange={handleFormChange}
                />
              </div>
              {formErrors?.lastName && (
                <p className="form-error">{formErrors?.lastName}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  User Name (Email Address) <span className="mandatory">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder={PlaceHolder?.EMAIL}
                  name="userName"
                  id="userName"
                  value={formValues.userName}
                  onChange={handleFormChange}
                  disabled={formValues.id ? true : false}
                ></input>
              </div>
              {!formValues?.id && formErrors.userName && (
                <p className="form-error">{formErrors.userName}</p>
              )}
            </div>
            {!formValues?.id && (
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                <div>
                  <label>
                    Password <span className="mandatory">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      className="form-control"
                      type={showPwd ? "text" : "password"}
                      placeholder={PlaceHolder?.PASSWORD}
                      name="password"
                      id="password"
                      value={formValues.password}
                      onChange={handleFormChange}
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        onClick={() => setShowPwd(!showPwd)}
                        tabIndex="-1"
                        style={{
                          border: "1px solid #B4BABF",
                          borderLeft: "none",
                          backgroundColor: "#F9FBFC",
                          borderRadius: "0 6px 6px 0",
                          padding: "0 10px",
                          cursor: "pointer",
                          color: "#6c757d"
                        }}
                      >
                        <i className={`fas ${showPwd ? "fa-eye" : "fa-eye-slash"}`}></i>
                      </button>
                    </div>
                  </div>
                </div>
                {formErrors.password && (
                  <p className="form-error">{formErrors.password}</p>
                )}
              </div>
            )}
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  User Role <span className="mandatory">*</span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  hideSelectedOptions={false}
                  allowSelectAll={true}
                  options={userRoleDrp}
                  onChange={handleUserRoleChange}
                  value={UserRoleName}
                  name="roleId"
                  id="roleId"
                  placeholder={PlaceHolder?.SELECT_USER_ROLE}
                  styles={style}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
              {formErrors?.roleId && (
                <p className="form-error">{formErrors?.roleId}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Phone Number <span className="mandatory">*</span>
                </label>
                <PhoneNumberComponent errors={formErrors} setValues={setFormValues} setErrors={setFormErrors} filedName="phone" values={formValues} />
              </div>
              {formErrors?.phone && (
                <p className="form-error">{formErrors?.phone}</p>
              )}
            </div>
            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  {userType
                    ? userType.value === "2"
                      ? "Distributor"
                      : "Company"
                    : "Company"}{" "}
                  Name
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  hideSelectedOptions={false}
                  allowSelectAll={true}
                  options={
                    userType?.value === "2" ? distributorDrp : companyDrp
                  }
                  onChange={handleCompanyChange}
                  value={companyName}
                  name="userCompanyId"
                  id="userCompanyId"
                  styles={style}
                  placeholder={`Choose ${userType?.value === "2" ? "distributor" : "company"
                    } name`}
                  isDisabled={userType === null}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
              {formErrors?.userCompanyId && (
                <p className="form-error">{formErrors?.userCompanyId}</p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Department <span className="mandatory">*</span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  hideSelectedOptions={false}
                  allowSelectAll={true}
                  options={departmentDrp}
                  onChange={handleDepartmentChange}
                  value={departmentName}
                  name="department"
                  id="department"
                  placeholder={PlaceHolder?.SELECT_DEPARTMENT}
                  styles={style}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
              {formErrors?.department && (
                <p className="form-error">{formErrors?.department}</p>
              )}
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Designation <span className="mandatory">*</span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  hideSelectedOptions={false}
                  allowSelectAll={true}
                  options={designationDrp}
                  onChange={handleDesignationChange}
                  value={designationName}
                  name="designation"
                  id="designation"
                  placeholder={PlaceHolder?.SELECT_DESIGNATION}
                  styles={style}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
              {formErrors?.designation && (
                <p className="form-error">{formErrors?.designation}</p>
              )}
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
              <div>
                <label>
                  Reporting To <span className="mandatory">*</span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  hideSelectedOptions={false}
                  allowSelectAll={true}
                  options={userReportDrp}
                  onChange={handleUserReportingChange}
                  value={UserReportingName}
                  name="reportingTo"
                  id="reportingTo"
                  placeholder={PlaceHolder?.SELECT_REPORTING}
                  styles={style}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
              {formErrors?.reportingTo && (
                <p className="form-error">{formErrors?.reportingTo}</p>
              )}
            </div>
          </div>
          <div className="row">
            {formValues?.id && (<>
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="isActive"
                    name="isActive"
                    checked={formValues.isActive ? true : false}
                    onChange={handleToggleBlockChange}
                  />
                  <label className="custom-control-label" htmlFor="isActive">
                    {formValues.isActive ? "Hide User" : "Show User"}
                  </label>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="loginDisabled"
                    name="loginDisabled"
                    checked={formValues.loginDisabled ? true : false}
                    onChange={handleToggleChange}
                  />
                  <label className="custom-control-label" htmlFor="loginDisabled">
                    Disable login
                  </label>
                </div>
              </div>
            </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserInformation;